{
  "/urlPrefix": "/services-analyse-donnees",
  "/aboutdas": "/apropossad",
  "/aaw": "/etaa",
  "/cae": "/eac",
  "/faq": "/faq",
  "/gae": "/eag",
  "/hub": "/guichet",
  "/overview": "/apercu",
  "/pricing": "/cout",
  "/termsAndConditions": "/conditions-d-utilisation",
  "/vdlHub": "/guichet-lvd",

  "aaw": "Espace de travail d'analyse avancée",
  "aawAcronym": "ETAA",
  "aawDash": "Tableau de bord ETAA",
  "aawDashboard": "Tableau de bord Espace de travail d'analyse avancée",
  "about": "À propos",
  "aboutCanadaCa": "À propos de Canada.ca",
  "aboutGov": "Au sujet du gouvernement",
  "aboutSite": "À propos de ce site",
  "account": "Compte",
  "active": "actif",
  "azureAccount": "Compte Azure",
  "azureLearningGuide": "Guide de formation sur Azure",
  "cae": "Environnement d'analyse collaboratif",
  "caeAcronym": "EAC",
  "caeDash": "Tableau de bord EAC",
  "caeDashBoard": "Tableau de bord Environnement d'analyse collaboratif",
  "cancel": "Annuler",
  "contactEmail": "Adresse courriel de contact",
  "contactUs": "Contactez-nous",
  "dasToolsAndGuides": "Outils et guides des SAD",
  "dateMod": "Date de modification ",
  "departments": "Ministères et organismes",
  "documentation": "Documentation",
  "environments": "Environnements",
  "faq": "Foire aux questions (FAQ)",
  "gae": "Environnement d'analyse géospatiale",
  "gaeAcronym": "EAG",
  "gaeDash": "Tableau de bord EAG",
  "gaeDashBoard": "Tableau de bord Environnement d'analyse géospatiale",
  "getStarted": "Commencer",
  "canadaLogo": "Symbole du gouvernement du Canada",
  "close": "Fermer",
  "daaas": "Services d'analyse des données",
  "daaasAcronym": "SAD",
  "daaasBreadCrumb": "À propos des SAD",
  "daaasBreadCrumbCanadaca": "Vous êtes ici : ",
  "dasTools": "Les SAD vous donnent accès aux outils énumérés ci-dessous et vous permettent de personnaliser votre expérience selon vos besoins. Les outils peuvent être utilisés dans trois environnements de travail différents, tous conçus pour servir différents types de projets. Lorsque vous avez amorcé un projet avec les SAD, vous pouvez accéder directement aux outils connexes à partir de ce guichet.",
  "dashboard": "tableau de bord",
  "feedback": "Commentaires",
  "freepik": "Freepik",
  "help": "Aide",
  "home": "Accueil",
  "howGovWorks": "Comment le gouvernement fonctionne",
  "hrefMsFormsGetStarted": "https://forms.office.com/pages/responsepage.aspx?id=mR-PJT3ux0K_xXrxsjQ-ApbSRgATuERFkV3XLiwQ8xFUQ1NHRzBVWEFYUktZRzBJRDIwUDZFSDQ0USQlQCN0PWcu&lang=fr-CA",
  "hrefStatcanLicence": "https://www.statcan.gc.ca/fr/reference/licence",
  "hrefStatcanPrivacy": "https://www.statcan.gc.ca/fr/reference/privee",
  "hrefStatcanStart": "https://www.statcan.gc.ca/fr/debut",
  "hrefStatcanTermsConditions": "https://www.statcan.gc.ca/fr/reference/avis",
  "hub": "Guichet",
  "hubInfoText": "Veuillez noter qu'à l'heure actuelle, certains outils peuvent ne pas être accessibles aux fins d'utilisation dans les deux langues officielles. Statistique Canada a entrepris des démarches pour s'assurer que tous les produits de données et outils accessibles sur la plateforme des SAD soient offerts dans les deux langues officielles. Pour obtenir plus de renseignements, veuillez consulter les différents guides ci-dessous. ",
  "illustBy": "Illustration par",
  "langSelection": "Sélection de la langue",
  "lastMod": "Dernière modification le",
  "loading": "Chargement",
  "main": "Principal",
  "menu": "Menu",
  "mobileApps": "Applications mobiles",
  "myHub": "Guichet des SAD",
  "news": "Nouvelles",
  "newTab": "Ouvrira dans un nouvel onglet",
  "openGov": "Gouvernement ouvert",
  "overview": "Aperçu",
  "primeMinister": "Premier ministre",
  "privacy": "Confidentialité",
  "profile": "Profil",
  "protectedB": "Protégé B",
  "publicService": "Fonction publique et force militaire",
  "reporting": "Rapports à l'échelle du gouvernement",
  "signIn": "Connexion",
  "signOut": "Se déconnecter",
  "skipFooter": "Passer au contenu du pied de page",
  "skipMain": "Passer au contenu principal",
  "socialMedia": "Médias sociaux",
  "startaProject": "Démarrer un nouveau projet",
  "statCan": "Statistique Canada",
  "terms": "Avis",
  "toGetStarted": "Pour commencer, cliquez sur « Démarrer un nouveau projet » et remplissez le formulaire pour nous faire part des besoins de votre projet. Lorsque le formulaire sera rempli, un représentant des SAD communiquera avec vous pour discuter des prochaines étapes et entamer le processus d'intégration. ",
  "topOfPage": "Haut de la page",
  "trainingResources": "Ressources de formation",
  "dctermsCreator": "Gouvernement du Canada, Statistique Canada",
  "dctermsLanguage": "fra",
  "dctermsSubject": "nul",
  "vdlHub": "Guichet LVD"
}
